<template>
  <div class="profile-page first_page" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <section class="section" v-if="isload">
      <div class="container-fluid  ">
        <div class="col-12 col-md-6 col-lg-5">
          <UserCard   :user="developer" />
        </div>
        <div class="row mt-3 mb-3 ml-3">

          <router-link tag="a" class="btn" :to="{name: 'developer', params: { username: this.developer.username }}">Все работы
          </router-link>
          <router-link class="btn" :to="{name: 'reviewpage', params: { username: this.developer.username }}" tag="a">Отзывы</router-link>
          <router-link class="btn" tag="a" v-if="developer.isshop && developer.isshop==1 && developer.shop_setting &&  developer.shop_setting.status && developer.shop_setting.status=='on'" :to="{name: 'developer_catalog', params: { username: this.developer.username }}">Каталог</router-link>

        </div>
        <div class="col-12 mt-3 mb-3 section_gray_bg">


          <h4 >Информация о работе</h4>
          <p>Категория:{{ work.category.name }}</p>
          <p>Дата {{ work.date_start }} - {{ work.date_end }}</p>


          <div class="row ">
            <editorjsrender class="ml-3" v-if="isload " :blocks_json="work.json.blocks"></editorjsrender>
          </div>

        </div>

      </div>

    </section>


  </div>
</template>
<script>
import {eventBus} from "@/main";
import Vue from "vue";
import Api from "@/models/Api";
import Editorjsrender from "@/models/Editorjsrender.vue";
import UserCard from "@/components/Custom/UserCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "developer",
  data() {
    return {
      'more_btn': '<button  class="btn">Посмотреть работу</button>',
      "isload": false,
      'developer': {},
      'work': {},
      'image_url': null,

    }
  },
  mounted() {
    var app = this;
    Api.loadDeveloperWork(this.$route.params.username, this.$route.params.work_id, function (developer_data, work_data) {
      app.image_url = Vue.config.IMAGE_URL;
      app.developer = developer_data;
      app.work = work_data;


      app.isload = true;
    },function(){
      app.$router.push({name:'404'});
    });

  },
  methods: {},
  components: {
    'UserCard':UserCard,
    'editorjsrender': Editorjsrender,
    LoadingBlock
  }
};
</script>
<style>
</style>
